import React, {Component, Fragment} from "react";
import styled, { keyframes } from "styled-components";
import HeadlineSegment from "./HeadlineSegment";
import ShadowHashlink from "../containers/ShadowHashlink";
import ReactMarkdown from "react-markdown";
import {Button} from "../pages/Landing/ServicesSection";

const MapsContainer = styled.iframe`
  flex: 1;
`;

const ConsentContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #b095ff;
  flex-direction: column;
  color: white;
  padding: 5em 2.5em;
  text-align: center;
  
  div {
    max-width: 60ch;
    margin-bottom: 1em;
    font-size: 1.5em;
  }
  
  a {
    color: white;
  }

  @media (max-width: 750px) {
    padding: 2.5em 1.5em 2.5em 1.5em;
  }
`;

const Container = styled.div`
  margin: 2.5em 5em 2.5em 5em;
  max-width: 100%;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: 4fr 6fr;
  background: linear-gradient(90deg, #cebfff, #9f7fff);
  position: relative;

  @media (max-width: 750px) {
    grid-template-columns: 1fr;
    grid-template-rows: 2fr 3fr;
    text-align: center;
  }

  @media (max-width: 500px) {
    margin: 2.5em;
  }

  @media (max-width: 400px) {
    margin: 1.5em;
  }
`;

const Maps = styled.div`
  display: flex;
`;

const Pane = styled.div`
  font-size: 1.5em;
  font-family: Raleway, sans-serif;
  font-weight: 600;
  padding: 5em;
  color: white;

  @media (max-width: 750px) {
    grid-row: 1;
    padding: 2.5em 1.5em 2.5em 1.5em;
  }
`;

class ContactSegment extends Component {

    constructor(props) {
        super(props);

        this.state = { loadIframes: false };
    }

    render() {
        const { locality, cms } = this.props;

        return (
            <Container>
                <ShadowHashlink id="kontakt" offset="-75%" mobileOffset="-12.5%" />
                <Maps>
                    {
                        this.state.loadIframes ? (
                            <MapsContainer
                                src={
                                    cms[locality === 0 ? "secondary-locality" : "primary-locality"][
                                        "embedded-map-link"
                                        ]
                                }
                                frameBorder="0"
                                sandbox="allow-scripts"
                                style={{ border: 0 }}
                            />
                        ) : (
                            <ConsentContainer>
                                <div>
                                    Diese Karte wird mit Google Maps eingebunden. Dabei werden personenbezogene Daten an Google übermittelt. <a href="/impressum">Mehr erfahren</a>
                                </div>
                                <Button onClick={() => this.setState({ loadIframes: true })}>Google Maps laden</Button>
                            </ConsentContainer>
                        )
                    }
                </Maps>
                <Pane>
                    <ReactMarkdown
                        source={
                            cms[locality === 0 ? "secondary-locality" : "primary-locality"][
                                "contact-section-content"
                                ]
                        }
                    />
                </Pane>
            </Container>
        )
    }
}

export default ContactSegment;



// WEBPACK FOOTER //
// /opt/build/repo/src/segments/ContactSegment.js